async function getListPartnerNotice(page, sortProp) {
  const params = {
    page: page,
    key: sortProp.key,
    dir: sortProp.dir
  };
  const queryParams = new URLSearchParams(params);

  return fetch('/api/notices/partner?' + queryParams
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getListUserNotice(page, sortProp) {
  const params = {
    page: page,
    key: sortProp.key,
    dir: sortProp.dir
  };
  const queryParams = new URLSearchParams(params);

  return fetch('/api/notices/user?' + queryParams
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getListPartnerNotice, getListUserNotice }
